"use client";

import {get_mega_menus_proxy} from '@core/services/megamenu';
import {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {useAuthContext} from "@core/helpers/client/contexts/AuthContext";

export const MenusContext = createContext(null);

export const MenusContextProvider = ({children, menuKeys = []}) => {
	const megaMenuKeys = useMemo(() => menuKeys, [menuKeys]);
	const [menus, set_menus] = useState({});
	const [menus_loading, set_menus_loading] = useState(true)
	const {token} = useAuthContext()

	const get_menus = async () => {
		if (megaMenuKeys?.length > 0) {
			set_menus_loading(true);
			const result = await get_mega_menus_proxy({menu_keys: megaMenuKeys})

			const _menus = {}
			if (result?.status) {
				result?.data?.forEach(item => {
					_menus[item?.key] = item?.value
				})
				set_menus(_menus)
			}
			set_menus_loading(false);
		}
	}

	useEffect(() => {
		get_menus()
	}, [token, megaMenuKeys])

	const values = useMemo(() => ({
		menus,
		set_menus,
		menus_loading,
		set_menus_loading
	}), [menus, menus_loading]);

	return (
		<MenusContext.Provider value={{...values}}>
			{children}
		</MenusContext.Provider>
	);
};

export const useMenusContext = () => useContext(MenusContext)